import React, { forwardRef } from 'react';
import { Stepper } from 'zarm';

import UItem from '../item';
import { BaseWidgetProps } from '../../utils/type';
import { clearObj } from '../../utils/tools';

export interface StepperProps extends BaseWidgetProps {
  value?: any;
  defaultValue?: any;
  min?: number;
  max?: number;
  step?: number;
  placeholder?: string;
  readOnly?: boolean;
  className?: string;
  validate?: {
    rules: any[];
  };
}

const StepperContent = forwardRef((props: StepperProps, ref: any) => {
  const {
    prefixCls,
    value,
    defaultValue,
    readOnly,
    ...rest
  } = props;

  // 只读
  if (readOnly) {
    return (
      <div className={`${prefixCls}-readOnly`}>
        {value || defaultValue || ''}
      </div>
    );
  }

  return (
    <Stepper
      ref={ref}
      defaultValue={value || defaultValue}
      {...rest}
    />
  );
});

// 表单 步进器组件
function UStepper(props: StepperProps) {
  const {
    value,
    defaultValue,
    placeholder,
    min,
    max,
    step,
    readOnly,
    _crengine,
    prefixCls = 'crm-stepper',
    className,
    ...rest
  } = props;

  // 子项内容改变的时候进行数据更新
  const onValueChange = (selected: any) => {
    const { onChange, ...restProps } = props;

    if (onChange) {
      onChange({
        ...restProps,
        value: selected,
      });
    }
  }

  const stepperProps = clearObj({
    prefixCls,
    value,
    defaultValue,
    placeholder,
    min,
    max,
    step,
    readOnly,
    onChange: onValueChange,
  });

  const { form } = _crengine || {};

  // 如果wform存在 则去除input组件的某些属性
  if (form) {
    delete stepperProps.value;
    delete stepperProps.defaultValue;
    delete stepperProps.onChange;
  }

  return (
    <UItem
      {...rest}
      itemType="stepper"
      _crengine={_crengine}
      initialValue={value || defaultValue}
      onChange={onValueChange}
    >
      <StepperContent {...stepperProps} />
    </UItem>
  );
}

export default UStepper;
